import { Navigate } from "@/components/_molecules/navigation-controls/navigate";
import { lazyRoute } from "@/routes/lazy-route";

const FocusAreaClimateActionListAllPage = lazyRoute(() => import("./$focusAreaId/climate-actions/(list)/focus-area-climate-action-list.all.page"), "FocusAreaClimateActionListAllPage");
const FocusAreaClimateActionListDashboardPage = lazyRoute(() => import("./$focusAreaId/climate-actions/(list)/focus-area-climate-action-list.dashboard.page"), "FocusAreaClimateActionListDashboardPage");
const FocusAreaClimateActionListLayout = lazyRoute(() => import("./$focusAreaId/climate-actions/(list)/focus-area-climate-action-list.layout"), "FocusAreaClimateActionListLayout");
const FocusAreaClimateActionListRootLayout = lazyRoute(() => import("./$focusAreaId/climate-actions/focus-area-climate-action-list-root.layout"), "FocusAreaClimateActionListRootLayout");
const FocusAreaLayout = lazyRoute(() => import("./$focusAreaId/focus-area.layout"), "FocusAreaLayout");
const FocusAreaListLayout = lazyRoute(() => import("./focus-area-list.layout"), "FocusAreaListLayout");
const FocusAreaListPage = lazyRoute(() => import("./focus-area-list.page"), "FocusAreaListPage");
const FocusAreaSettingsPage = lazyRoute(() => import("./focus-area-settings.page"), "FocusAreaSettingsPage");

export const focusAreaRoutes = [
  {
    path: "focus-area",
    element: <FocusAreaListLayout />, // inits currentFocusAreaListContext
    children: [
      { path: "", element: <FocusAreaListPage /> },
      {
        path: ":focusAreaId",
        element: <FocusAreaLayout />,
        children: [
          { path: "", element: <Navigate to="climate-actions" replace /> },
          {
            path: "climate-actions",
            element: <FocusAreaClimateActionListRootLayout />, // inits currentClimateActionListContext
            children: [
              {
                path: "",
                element: <FocusAreaClimateActionListLayout />, // shared header with tabs
                children: [
                  { path: "", element: <Navigate to="all" replace /> },
                  { path: "all", element: <FocusAreaClimateActionListAllPage /> },
                  { path: "dashboard", element: <FocusAreaClimateActionListDashboardPage /> },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];

export const focusAreaSettingsRoutes = [
  {
    path: "focus-area",
    element: <FocusAreaSettingsPage />,
  },
];
